import React, { useEffect, useRef, useState } from 'react';
import { motion } from "motion/react";
import { Marquee } from "../Components/magicui/marquee";
import { Link } from 'react-router-dom';

import { cn } from "../lib/utils";
import { FaInstagram, FaFacebook, FaLinkedinIn } from 'react-icons/fa';

import logo1 from '../Images/Collaboration/logo1.webp';
import logo2 from '../Images/Collaboration/logo2.webp';
import logo3 from '../Images/Collaboration/logo3.webp';
import logo4 from '../Images/Collaboration/logo4.webp';
import logo5 from '../Images/Collaboration/logo5.webp';
import logo6 from '../Images/Collaboration/logo6.webp';
import logo7 from '../Images/Collaboration/logo7.webp';
import logo8 from '../Images/Collaboration/logo8.webp';
import mainVideo from '../Images/Untitled.mp4'
import mainLeft from '../Images/mainLeft.webp'
import mainRight from '../Images/mainRight.webp'
import comingSoon1 from '../Images/comingSoon1.webp'
// import comingSoon2 from '../Images/comingSoon2.webp'
import icon1 from '../Images/Icons/Looking to build softwarePNG.svg';
import icon2 from '../Images/Icons/DIY Guided CoursesPNG.svg';
import icon3 from '../Images/Icons/Marketing PNG.svg';
import icon4 from '../Images/Icons/Github repoPNG.svg';
import icon5 from '../Images/Icons/Fractional CTOPNG.svg';
import icon6 from '../Images/Icons/Product DesignPNG.svg';

import stackIcon1 from '../Images/Icons/View Our Open Source ProjectsPNG.svg';
import stackIcon2 from '../Images/Icons/Stack with TechPNG.svg';
import stackIcon3 from '../Images/Icons/Looking to Build Your Own AppPNG.svg';
import ParticipationContact from '../Components/ContactForm/ParticipationContact';

import { handleOpenModal, handleCloseModal } from '../Components/Header'
import ContactUs from '../Components/ContactForm/ContactUs';
import { FaXTwitter } from 'react-icons/fa6';

function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // videoElement.muted = false;
            videoElement.play().catch(error => {
              console.error("Error attempting to play video:", error);
            });
          } else {
            videoElement.pause();
          }
        });
      },
      { threshold: 0.5 }
    );
    observer.observe(videoElement);
    return () => {
      observer.unobserve(videoElement);
    };
  }, []);

  const services = [
    {
      icon: icon1,
      title: "Looking to build software?",
      description: "Hire a developer or a whole team to support your software development needs."
    },
    {
      icon: icon2,
      title: "DIY Guided Courses",
      description: "Learn, Practice and Build software on your own with our DIY guided courses, with mentors from top companies."
    },
    {
      icon: icon3,
      title: "Marketing And Ops",
      description: "Get the top-tier team to assist you with marketing, sales, and ops."
    },
    {
      icon: icon4,
      title: "Access To Our GitHub Repo",
      description: "Describe what this feature does, and how it benefits your customers."
    },
    {
      icon: icon5,
      title: "Fractional CTO",
      description: "Access top-tier tech talent without the full-time commitment. FCTOs provide scalable expertise, tailored to your specific needs."
    },
    {
      icon: icon6,
      title: "Product Design",
      description: "Share your product idea, and our team of expert designers will work with you to turn your vision into reality."
    }
  ];

  const tools = [
    {
      imgSrc: logo1,
      imgAlt: "YSM logo",
      description: "YSM Construction and Co."
    },
    {
      imgSrc: logo2,
      imgAlt: "Woodin logo",
      description: "Woodin"
    },
    {
      imgSrc: logo3,
      imgAlt: "FUTR logo",
      description: "FUTR: Youth Sports Nutrition"
    },
    {
      imgSrc: logo4,
      imgAlt: "Trivia logo",
      description: "Trivia Cult: Card Game"
    },
    {
      imgSrc: logo5,
      imgAlt: "Zitron logo",
      description: "Zitron Soda by Kili's."
    },
    {
      imgSrc: logo6,
      imgAlt: "VIBEZ logo",
      description: "VIBEZ by WINTERGREEN."
    },
    {
      imgSrc: logo7,
      imgAlt: "BOOM TOWN logo",
      description: "BOOM TOWN MUSHROOM GUMMIES"
    },
    {
      imgSrc: logo8,
      imgAlt: "O'Sullivan logo",
      description: "Debut Novel by Brian O'Sullivan"
    },
  ];

  const firstRow = tools.slice(0, tools.length / 2);
  const secondRow = tools.slice(tools.length / 2);

  const ReviewCard = ({ imgSrc, description }) => {
    return (
      <figure
        className={cn(
          "relative w-64 cursor-pointer overflow-hidden rounded-xl border p-4",
          "border-[gray-950]/[.1] bg-gray-950/[.01] hover:bg-gray-950/[.05]",
        )}
      >
        <div className="flex justify-center flex-row items-center gap-2">
          <img className=" object-cover" width="50" height="50" alt="" src={imgSrc} />
        </div>
        <blockquote className="text-center mt-2 text-base text-black font-semibold">{description}</blockquote>
      </figure>
    );
  };

  return (
    <>
      <div className="bg-white flex items-center justify-center h-screen md:h-full mt-0 md:mt-40 mb-0 md:mb-28 ">
        <div className="w-full px-4 md:px-20">
          <div className="flex flex-col md:flex-row items-center justify-center space-y-14 md:space-y-0 md:space-x-8">
            <motion.div
              className="text-center md:text-left space-y-5 w-full md:w-1/2"
            >
              <motion.h1
                initial={{ scale: 0.5 }}
                transition={{ type: "spring", duration: 2, ease: "easeIn" }}
                animate={{ scale: 1 }}
                className="text-3xl md:text-4xl font-bold text-[#444444]">A Plug For Your Software Development Needs!</motion.h1>
              <p className="text-black mt-4">Empowering Innovation, Delivering Excellence.</p>
              <div className='flex items-center gap-4'>
                <button
                  onClick={() => handleOpenModal(setIsModalOpen)}
                  className="mt-4 px-8 py-2 text-white font-semibold bg-gradient-to-r from-[#e00a7e] to-[#6c32ee] rounded-lg transform transition-all duration-300 hover:scale-[1.02]">
                  PARTICIPATE IN OUR NEXT VIDEO
                </button>
                <Link to='/contact'>
                  <button
                    className="mt-4 px-8 py-2 text-[#e00a7e] font-semibold bg-transparent border border-[#e00a7e] rounded-lg transform transition-all duration-300 hover:scale-[1.02]"
                  >
                    CONTACT US
                  </button>
                </Link>
              </div>
            </motion.div>

            <motion.div
              initial={{ x: 200 }}
              transition={{ type: "spring", duration: 3, ease: "easeOut" }}
              animate={{ x: 0 }}
              className="w-full md:w-1/2"
            >
              <div className=" h-64 border flex items-center justify-center">
                <video
                  ref={videoRef}
                  width="100%"
                  src={mainVideo}
                  className="rounded-xl"
                  controls
                  loop
                  autoPlay
                  controlsList="nodownload"
                  muted
                />
              </div>
            </motion.div>
          </div>
        </div>
      </div>


      <div className="bg-white mb-20">
        <div className="w-full px-4 md:px-16">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">
            Check out our latest update
          </h2>
          <div className="flex flex-col md:flex-row justify-center space-y-8 md:space-y-0 md:space-x-8">
            <motion.div
              initial={{ x: -200 }}
              transition={{ type: "spring", duration: 2, ease: "easeOut" }}
              whileInView={{ x: 0 }}
              viewport={{ once: true }}
              className="w-full md:w-64 rounded-lg overflow-hidden transition-shadow">
              <iframe className="h-[250px] md:h-[100%] w-full md:w-full rounded-lg mb-4" src="https://www.youtube.com/embed/F4hFLdOwfOc?si=nHB0YmJ9q2KvPpKb" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </motion.div>
            <motion.div
              initial={{ y: -100 }}
              transition={{ type: "spring", duration: 2, ease: "easeOut" }}
              whileInView={{ y: 0 }}
              viewport={{ once: true }}
              className="w-full md:w-64 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
              <iframe className="h-[250px] md:h-[100%] w-full md:w-full rounded-lg mb-4" src="https://youtube.com/embed/hRXPvHOctjg?si=iLhpi7zeV_AG3ln3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </motion.div>
            <motion.div
              initial={{ x: 200 }}
              transition={{ type: "spring", duration: 2, ease: "easeOut" }}
              whileInView={{ x: 0 }}
              viewport={{ once: true }}
              className="w-full md:w-64 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
              <img src={comingSoon1} alt="title" className="w-full h-full object-cover" />
            </motion.div>
          </div>
        </div>
      </div>

      <motion.div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full px-4 md:px-16 mb-4 md:mb-20">
        {services.map((service, index) => (
          <div key={index} className="flex items-center p-4 rounded-lg bg-white">
            <div className=" p-3">
              <img
                src={service.icon}
                alt='icons'
                className="h-[100px] w-[100px] object-contain"
                style={{ maxWidth: '60px', maxHeight: '60px' }}
              />
            </div>
            <div className="ml-4">
              <h3 className="font-semibold text-gray-800 mb-1">{service.title}</h3>
              <motion.p
                initial={{ scale: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                className="text-gray-800 text-sm"
              >
                {service.description}
              </motion.p>
            </div>
          </div>
        ))}
      </motion.div>


      <div className="w-full px-4 md:px-16 flex flex-col md:flex-row items-center justify-center bg-white p-6">
        <div className="w-full md:w-1/2 p-5">
          <img
            src={mainLeft}
            alt="Placeholder representing software innovations"
            className="rounded-lg shadow-md"
          />
        </div>
        <div className="w-full md:w-1/2 p-5">
          <h1 className="text-2xl md:text-3xl font-bold text-black mb-4">
            Discover the Latest Innovations in Software
          </h1>
          <p className="text-black font-bold">
            Check out our software builds {` `}
            <span className="text-black font-normal">
              to experience the cutting-edge features and performance enhancements we've developed. Our dedicated team is committed to delivering top-notch solutions tailored to your specific needs. Explore our latest releases and see how they can revolutionize your workflow.
            </span>
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-16 flex flex-col-reverse md:flex-row items-center justify-center bg-white p-6 mb-20">
        <div className="w-full md:w-1/2 p-5">
          <h1 className="text-2xl md:text-3xl font-bold text-black mb-4">
            Experience the Future of User Experience
          </h1>
          <p className="text-black font-bold">
            Check out our UX/UI design builds {` `}
            <span className="text-black font-normal">
              to witness the seamless fusion of aesthetics and functionality. Our expert designers have crafted intuitive and visually stunning interfaces that prioritize user satisfaction.
            </span>
          </p>
        </div>
        <div className="w-full md:w-1/2 p-5">
          <img
            src={mainRight}
            alt="Placeholder representing software innovations"
            className="rounded-lg shadow-md"
          />
        </div>
      </div>


      <div className="bg-[#f7f6f6] flex flex-col md:flex-row py-16 justify-center items-center space-y-8 md:space-y-0 md:space-x-8 mb-0">
        <div className="text-center max-w-xs">
          <div className="bg-white p-3 rounded-2xl inline-block mb-4 shadow-md">
            <img src={stackIcon1} alt='icons' className="h-[100px] w-[100px] object-contain" style={{ maxWidth: '45px', maxHeight: '45px' }} />
          </div>
          <h2 className="text-xl font-semibold text-black">View Our Open Source Projects</h2>
          <p className="text-black mt-2">Check out our open source projects built with React, Python, and much more...</p>
        </div>

        <div className="text-center max-w-xs">
          <div className="bg-white p-3 rounded-2xl inline-block mb-4 shadow-md">
            <img src={stackIcon2} alt='icons' className="h-[100px] w-[100px] object-contain" style={{ maxWidth: '45px', maxHeight: '45px' }} />
          </div>
          <h2 className="text-xl font-semibold text-black">Stack with Tech</h2>
          <p className="text-black mt-2">Our podcast covering software and design news, articles, issues, pull requests, libraries, and apps.</p>
        </div>

        <div className="text-center max-w-xs">
          <div className="bg-white p-3 rounded-2xl inline-block mb-4 shadow-md">
            <img src={stackIcon3} alt='icons' className="h-[100px] w-[100px] object-contain" style={{ maxWidth: '45px', maxHeight: '45px' }} />
          </div>
          <h2 className="text-xl font-semibold text-black">Looking to Build Your Own App?</h2>
          <p className="text-black mt-2">
            <em>Ready to take the next step?*</em> No matter where you are in your project journey—from initial concept to full-fledged proposal—we're here to help.
          </p>
        </div>
      </div>

      {/* <div className="px-4 md:px-16 text-center p-8 bg-white rounded-md mb-20">
        <h1 className="text-3xl font-bold text-[#444444] mb-4">Remote Work</h1>
        <p className="text-gray-600 mb-8 text-sm md:text-base px-4 md:px-60">
          We're a close-knit team that supports each other and has a lot of fun. Our virtual meetups, guild meetings, and lunchtime games keep us connected, while our annual team retreat provides opportunities for in-person bonding and strategic planning.
        </p>
        <button className="px-6 py-3 text-lg md:text-3xl font-bold tracking-wide bg-gradient-to-r from-[#e00a7e] to-[#6c32ee] text-white rounded-md shadow-md hover:opacity-90 transition duration-300 ease-in-out transform hover:scale-[1.02]">
          Be A Part Of Our Team
        </button>
      </div> */}


      <div className="relative flex py-16 border w-full flex-col items-center justify-center overflow-hidden rounded-lg  bg-background">
        <Marquee pauseOnHover className="[--duration:20s]">
          {firstRow.map((review) => (
            <ReviewCard key={review.username} {...review} />
          ))}
        </Marquee>
        <Marquee reverse pauseOnHover className="[--duration:20s]">
          {secondRow.map((review) => (
            <ReviewCard key={review.username} {...review} />
          ))}
        </Marquee>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-white dark:from-background"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-1/3 bg-gradient-to-l from-white dark:from-background"></div>
      </div>


      <ContactUs />


      <div className="w-full px-4 md:px-16 flex flex-col md:flex-row justify-center items-center py-16 bg-[#f7f6f6] mb-10">

        <div className="flex items-center flex-col space-x-4 mb-4 md:mb-0">
          <div className="text-center mb-6">
            <h2 className="mb-4 text-3xl font-bold bg-gradient-to-r from-purple-600 to-pink-500 bg-clip-text text-transparent">
              Connect With Us
            </h2>
            <p className="text-black max-w-2xl mx-auto">
              Join our vibrant community across social platforms and stay updated with the latest news, events, and exclusive content.
            </p>
          </div>
          <div className="flex space-x-2">
            <a
              href="https://www.facebook.com/share/15vZFNMXNN/?mibextid=wwXIfr"
              target='blank'
              className="p-2 rounded-full flex items-center justify-center transition-transform transform hover:scale-110"
              style={{
                background: 'linear-gradient(45deg, #1877F2, #3b5998)',
              }}
              aria-label="Follow us on Facebook"
            >
              <FaFacebook className="text-2xl text-white" />
            </a>

            <a
              href="https://www.instagram.com/learnwithstack?igsh=MThqbW0zdHoyOG1qNQ=="
              target='blank'
              className="p-2 rounded-full flex items-center justify-center transition-transform transform hover:scale-110"
              style={{
                background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
              }}
              aria-label="Follow us on Instagram"
            >
              <FaInstagram className="text-2xl text-white" />
            </a>

            <a
              href="https://x.com/learnwithstack?s=21"
              target='blank'
              className="p-2 rounded-full flex items-center justify-center transition-transform transform hover:scale-110"
              style={{
                background: 'linear-gradient(45deg, #000000, #000000)',
              }}
              aria-label="Follow us on YouTube"
            >
              <FaXTwitter className="text-2xl text-white" />
            </a>

            <a
              href="https://www.linkedin.com/company/learn-with-stack/"
              target='blank'
              className="p-2 rounded-full flex items-center justify-center transition-transform transform hover:scale-110"
              style={{
                background: 'linear-gradient(45deg, #0077B5, #005582)',
              }}
              aria-label="Follow us on YouTube"
            >
              <FaLinkedinIn className="text-2xl text-white" />
            </a>
          </div>
        </div>
      </div>

      <ParticipationContact
        isOpen={isModalOpen}
        onClose={() => handleCloseModal(setIsModalOpen)}
        className={`${isModalOpen ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-opacity duration-800 ease-in-out`}
      />
    </>
  )
}

export default Home

